/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Device } from '../../models/device';
import { DeviceUpdateRequest } from '../../models/device-update-request';

export interface UpdateDevice$Params {

/**
 * Id of a resource.
 */
  id: string;
      body: DeviceUpdateRequest
}

export function updateDevice(http: HttpClient, rootUrl: string, params: UpdateDevice$Params, context?: HttpContext): Observable<StrictHttpResponse<Device>> {
  const rb = new RequestBuilder(rootUrl, updateDevice.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Device>;
    })
  );
}

updateDevice.PATH = '/api/v1/devices/{id}';
